import type { PublicEvent } from '@avh/shared';
import { useI18n } from '@/contexts/I18n';
import { formatDate } from '@/lib/format';

const LOW_STOCK = 20;

export function AvailabilityNote({ event }: { event: PublicEvent }) {
  const { t, locale } = useI18n();
  switch (event.salesState) {
    case 'sold_out':
      return <span className="text-sm font-semibold text-accent-700">{t.event.soldOut}</span>;
    case 'not_started':
      return <span className="text-sm text-muted">{t.event.notStarted(event.salesStart ? formatDate(event.salesStart, locale) : '')}</span>;
    case 'ended':
      return <span className="text-sm text-muted">{t.event.ended}</span>;
    case 'open':
      return event.available <= LOW_STOCK ? (
        <span className="text-sm font-semibold text-accent-700">{t.event.available(event.available)}</span>
      ) : null;
    default:
      throw new Error(`Unknown sales state ${String(event.salesState satisfies never)}`);
  }
}
